/**
 * Static furniture entity — desks, plants, shelves, etc.
 * Drawn at a grid position, no animation.
 */

import type { Sprite } from "../sprites/SpriteSheet.js";
import { Entity } from "./Entity.js";

export class FurnitureEntity extends Entity {
  private sprite: Sprite;

  constructor(id: string, col: number, row: number, sprite: Sprite, layer = 1) {
    super(id, col, row, layer);
    this.sprite = sprite;
    this.castsShadow = true;
  }

  update(_dt: number): void {
    // Static — no updates
  }

  draw(ctx: CanvasRenderingContext2D): void {
    const frame = this.sprite.frames[0];
    ctx.drawImage(
      frame,
      this.worldX - this.sprite.originX,
      this.worldY - this.sprite.originY,
    );
  }
}
